export default "__VITE_ASSET__a8c0f6d0__"